import { Navigate, useLocation } from "react-router-dom";
import { Loader2, Lock, LogOut } from "lucide-react";
import { useAuth, pageKeyForPath } from "@/context/AuthContext";
import { navItems } from "./Sidebar";
import ForcePasswordChange from "@/pages/ForcePasswordChange";

const NoAccess = ({ onLogout }) => (
  <div data-testid="no-access-message" className="flex min-h-screen flex-col items-center justify-center gap-3 bg-[#080C14] text-slate-400">
    <Lock className="h-8 w-8 text-slate-600" />
    <p className="text-sm">No pages have been assigned to your account yet. Ask an admin for access.</p>
    <button data-testid="no-access-logout-button" onClick={onLogout} className="mt-2 flex items-center gap-1.5 rounded-lg border border-slate-700 px-3 py-1.5 text-xs text-slate-300 transition-colors hover:bg-slate-800">
      <LogOut className="h-3.5 w-3.5" /> Sign out
    </button>
  </div>
);

export default function RequireAuth({ children }) {
  const { user, canAccess, logout } = useAuth();
  const { pathname } = useLocation();

  if (user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-screen items-center justify-center bg-[#080C14]">
        <Loader2 className="h-6 w-6 animate-spin text-blue-400" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace state={{ from: pathname }} />;
  if (user.must_change_password) return <ForcePasswordChange />;
  if (!canAccess(pageKeyForPath(pathname))) {
    const first = navItems.find((n) => canAccess(n.key));
    return first ? <Navigate to={first.to} replace /> : <NoAccess onLogout={logout} />;
  }
  return children;
}
